<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/01_Bosco-Parco-Serre.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Natura e Meraviglia</h3>
</div>
</div>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
<app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            La Calabria dei Parchi e delle Riserve detiene un patrimonio di natura protetta che copre circa il 40% dell’intero territorio regionale 
            che va dalle maestose cime dei Monti del Pollino e dell’Orsomarso, dove svettano i tenaci pini loricati, e poi si apre sull’immenso altopiano Silano,
             tra i più estesi d’Europa. Ancora più a sud raggiunge la Riserva delle Valli cupe e supera il punto più stretto della penisola italiana dove si inoltra 
             nei fitti boschi delle Serre avvolti da sacralità e leggenda, e da qui il passo è breve per approdare in Aspromonte, uno scrigno di biodiversità inestimabile 
             che si estende fin quasi a lambire lo Stretto.
            <br>
            <br>
            Al patrimonio di natura delle aree interne della Calabria si aggiunge quello degli oltre 800 Km di coste che offrono una varietà di fondali e 
            paesaggi davvero unici: dalla Costa dei Cedri, quella degli Dei, la Costa Viola, dei Gelsomini, degli Aranci, la Costa dei saraceni e quella degli Achei, 
            nomi che rievocano non solo luoghi splendidi ma anche l’incredibile storia che questa terra racchiude in sé amplificandone il fascino.
        </p>
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-md-4 col-12">
            <div class="row">
                <div class="col one" id="one">
                    <div class="card one">
                        <div class="card-body">
                            <div class="content-card">
                                <h1>Parchi<br />e Riserve</h1>
                                <a href="#">Scopri</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col four" id="four">
                    <div class="card four">
                        <div class="card-body">
                            <div class="content-card">
                                <h1>Musei e aree<br />archeologiche</h1>
                                <a href="#">Scopri</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2 col-12">
            <div class="col two" id="two">
                <div class="card two">
                    <div class="card-body">
                        <div class="content-card">
                            <h1>Siti<br />UNESCO</h1>
                            <a href="#">Scopri</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-12">
            <div class="row">
                <div class="col three" id="three">
                    <div class="card three">
                        <div class="card-body">
                            <div class="content-card">
                                <h1>Borghi storici</h1>
                                <a href="#">Scopri</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col six" id="six">
                    <div class="card six">
                        <div class="card-body">
                            <div class="content-card">
                                <h1>Luoghi d'arte<br />storia e<br />spiritualità</h1>
                                <a href="#">Scopri</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
